// Responsive scaling utility for better display on different screen sizes
export const applyResponsiveScaling = () => {
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const devicePixelRatio = window.devicePixelRatio || 1;

  // Detect common 14-inch display scenarios
  const is14InchDisplay = (
    // MacBook Pro 14" scenarios
    (screenWidth === 3024 && screenHeight === 1964) || // Native resolution
    (windowWidth >= 1512 && windowWidth <= 1728 && windowHeight >= 982 && windowHeight <= 1117) || // Scaled resolutions
    // Other common 14-inch displays
    (windowWidth >= 1366 && windowWidth <= 1440 && windowHeight >= 768 && windowHeight <= 900) ||
    // High-DPI 14-inch displays
    (windowWidth >= 1200 && windowWidth <= 1600 && windowHeight >= 800 && windowHeight <= 1200 && devicePixelRatio >= 2)
  );

  // Apply scaling for 14-inch displays
  if (is14InchDisplay) {
    const scaleFactor = 0.85; // Scale down to 85%
    document.documentElement.style.setProperty('--global-scale', scaleFactor.toString());
    document.body.style.zoom = scaleFactor.toString();
    
    // For Firefox (doesn't support zoom)
    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
      document.body.style.transform = `scale(${scaleFactor})`;
      document.body.style.transformOrigin = '0 0';
      document.body.style.width = `${100 / scaleFactor}%`;
    }
    
    console.log('Applied 14-inch display scaling:', scaleFactor);
  }
};

// Apply scaling on load and resize
export const initResponsiveScaling = () => {
  applyResponsiveScaling();
  
  // Reapply on window resize (for when users change browser zoom or window size)
  let resizeTimeout: NodeJS.Timeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(applyResponsiveScaling, 250);
  });
};

// CSS-based detection alternative
export const addResponsiveClasses = () => {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const devicePixelRatio = window.devicePixelRatio || 1;
  
  // Remove existing responsive classes
  document.body.classList.remove('is-14inch', 'is-high-dpi', 'needs-scaling');
  
  // Add appropriate classes
  if (windowWidth >= 1200 && windowWidth <= 1600 && windowHeight >= 800 && windowHeight <= 1200) {
    document.body.classList.add('is-14inch');
    
    if (devicePixelRatio >= 2) {
      document.body.classList.add('is-high-dpi');
    }
    
    document.body.classList.add('needs-scaling');
  }
};